import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import PrivacyPolicyLink from '@sputnik/components/PrivacyPolicyLink'
import { PRODUCT_CONST_STRINGS, URL } from '@sputnik/resources/constants'

import styles from './styles.module.scss'

const DashboardFooter = () => {
  const [getClassName] = useNameFormatter('DashboardFooter')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('links')]}>
        <TextLink
          href={URL.BILL_LEGAL_LINK}
          target='_blank'
        >
          <FormattedMessage
            defaultMessage='Legal'
            id='sputnik.DashboardFooter__7oFrM6'
          />
        </TextLink>
        <PrivacyPolicyLink
          alternateLinkString={
            <FormattedMessage
              defaultMessage='Privacy'
              id='sputnik.DashboardFooter__cXBJ7U'
            />
          }
        />
        <TextLink
          href={URL.BILL_SECURITY_LINK}
          target='_blank'
        >
          <FormattedMessage
            defaultMessage='Security'
            id='sputnik.DashboardFooter__Py189G'
          />
        </TextLink>
        <TextLink
          href={URL.BILL_HELP_CENTER_LINK}
          target='_blank'
        >
          <FormattedMessage
            defaultMessage='Help Center'
            id='sputnik.DashboardFooter__HtSDyc'
          />
        </TextLink>
        <div className={styles[getClassName('sign-in')]}>
          <FormattedMessage
            defaultMessage='Already a {BILL_SPEND_AND_EXPENSE} user?'
            id='sputnik.DashboardFooter__oB29Xv'
            values={{
              BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
            }}
          />
          <TextLink
            href={URL.DIVVY_PROD}
            size={TextLinkSizes.REGULAR}
            target='_blank'
          >
            <FormattedMessage
              defaultMessage='Log in here'
              id='sputnik.DashboardFooter__2SvpuI'
            />
          </TextLink>
        </div>
      </div>
      <div className={styles[getClassName('copyright')]}>
        <FormattedMessage
          defaultMessage='© 2025 {BILL} Operations, LLC'
          id='sputnik.DashboardFooter__k28y/w'
          values={{
            BILL: PRODUCT_CONST_STRINGS.BILL,
          }}
        />
      </div>
    </div>
  )
}

export default DashboardFooter
